import axios from 'axios';
import UtilService from "./UtilService";

class ApiService {
    constructor() {
        this.api = axios.create({
            baseURL: this.urlBase,
            headers: {
                //Authorization: "X7vGRfthgiN7fedy8b7Xy", // Homologação
                Authorization: 'CowJsEZNOOpNT_IZf_iAq' // Producao
            }
        });
    }
    urlBase = "https://app.haysystems.com.br"; // URL OFICIAL
    //urlBase = "http://192.168.15.10:1337"; // URL DESENVOLVIMENTO
    //urlBase = "http://177.170.25.178:1337"; // URL TESTES
    mensagemDefault = "Ops, parece que você está tendo problemas de conectividade, ou há algum problema em seu acesso. Tente novamente mais tarde ou entre em contato com nosso suporte.";

    atualizarContador = async (projeto) => {
        UtilService.showLoading(false);
        const retorno = await this.api.patch('/hay/projeto/' + projeto.id, {contador: (projeto.contador || 0) + 1}).catch(e => {
            console.log(e.response);
            alert("Falha de Acesso", this.mensagemDefault);
        });
        UtilService.hideLoading();
        if (retorno && retorno.data) {
            return retorno.data;
        }
    }
    consultaProjetos  = async (params) => {
        UtilService.showLoading(false);
        const retorno = await this.api.get('/hay/projeto?sort=createdAt+DESC&where={"ativo": true}').catch(e => {
            console.log(e.response);
            alert("Falha de Acesso", this.mensagemDefault);
        });
        UtilService.hideLoading();
        if (retorno && retorno.data) {
            return retorno.data;
        }
    }
}
export default new ApiService();